<template>
  <EUIPrimaryLayout>
    <template slot="header">
      <Header />
    </template>

    <template slot="footer">
      <Footer />
    </template>
  </EUIPrimaryLayout>
</template>

<script>
import { EUIPrimaryLayout } from 'eclipx.ui';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

export default {
  name: 'DragonballLayout',
  components: {
    EUIPrimaryLayout,
    Header,
    Footer
  }
};
</script>
